// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2OHNQ","content":"styles_content__SRVhl","checkbox":"styles_checkbox__1DXVo","checkboxLabel":"styles_checkboxLabel__31HkP"};